var M="MM/DD/YY, hh:mm A",D="MMM DD";export{D as DATE_FORMAT,M as DATE_TIME_FORMAT};
